import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientAction } from '../symbolClient.action';

type IDependencies = IClientApiDependencySegment;

export const updateSymbolClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) =>
  action$.pipe(
    isTypeOfAndGetPayload(SymbolClientAction.update.started),
    mergeMap((params) => {
      const { resolve, reject, serverId, ...payload } = params;

      return dependencies.api.updateClientSymbol(payload).pipe(
        mergeMap(() => {
          resolve?.();
          return [
            SymbolClientAction.update.done({ params }),
          ];
        }),
        catchApiError((error) => {
          const isHandled = reject?.(error.errorCode, error.description, error.params);
          return [
            SymbolClientAction.update.failed({ params, error }),
            ...(isHandled ? [] : [createApiErrorNotification(error)]),
          ];
        }),
      );
    }),
  );
